﻿import Repository from "./Repository";

const landenResource = "geography/landen";
const gemeentenResource = "geography/gemeenten";
const nationaliteitenResource = "geography/nationaliteiten";

export default {
  getLanden() {
    return Repository.get(landenResource);
  },
  getGemeenten() {
    return Repository.get(gemeentenResource);
  },
  getNationaliteiten() {
    return Repository.get(nationaliteitenResource);
  },
};
